import React, { useRef, useState } from "react";
import { Button, Divider } from "antd";
import "../Css/HomeProduct.css";
import Product from "../Components/Data/Product";
import "swiper/css";
import "swiper/css/navigation";
import { useNavigate } from "react-router-dom";
import { Fade } from "react-awesome-reveal";
import { FaArrowRightLong } from "react-icons/fa6";

const HomeProduct = () => {
  const [active, setActive] = useState("Melee Diamonds");
  const navigate = useNavigate();
  const sectionRef = useRef(null);

  const handleActive = (name) => {
    setActive(name);
    const offset = 80; // Change this value to adjust position
    const sectionTop = sectionRef.current?.getBoundingClientRect().top;
    window.scrollTo({
      top: window.scrollY + sectionTop - offset,
      behavior: "smooth",
    });
  };

  return (
    <>
      <section className="sectionDiv home-about-us-product-sec ">
        <div className="container">
          <h3 className="text-center home-about-us-title ">Our Product's</h3>
          <div className="home-about-us-line-outer-ant">
            <div className="home-about-us-line-inner-ant">
              <Divider />
            </div>
            <div className="home-about-us-dot-ant">
              <label>•</label>
            </div>
            <div className="home-about-us-line-inner-ant">
              <Divider />
            </div>
          </div>

          <div className="homeproductNew-main-card-container">
            <div className="row d-flex align-items-center justify-content-center">
              {Product?.map(({ img, name }, i) =>
                img ? (
                  <div className="col-lg-2 col-md-4 col-6 d-flex align-items-center justify-content-center">
                    <Fade triggerOnce direction="down">
                      <div
                        className={`homeproductNew-main-card ${
                          active === name && "active"
                        }`}
                        key={i}
                        onClick={() => handleActive(name)}
                      >
                        <img src={img} alt={`Best Diamond Dealer`} />
                        <p>{name}</p>
                      </div>
                    </Fade>
                  </div>
                ) : null
              )}
            </div>
          </div>
        </div>

        {Product?.filter((val) => val.name === active).map((value) => (
          <div className="container mt-5" ref={sectionRef}>
            <div className="row">
              <div className="col-md-6 order-2 order-md-1 d-flex justify-content-end align-items-center">
                <Fade triggerOnce direction="left">
                  <div
                    className="homeproduct-what-is-mele-diamond-main-div"
                    style={{ paddingRight: "20px" }}
                  >
                    <h4>{value.name}</h4>
                    <p>{value.decOne}</p>
                    <div>
                      <Button
                        className="homeproduct-shop-mele-diamond-btn mt-4"
                        style={{ borderRadius: 5 }}
                        onClick={() => navigate(value.slug)}
                      >
                        Know More <FaArrowRightLong />
                      </Button>
                    </div>
                  </div>
                </Fade>
              </div>
              <div className="col-md-6 order-1 order-md-2">
                <Fade triggerOnce direction="right">
                  <div className="imageDiv">
                    <div
                      className="imageView"
                      style={{
                        backgroundImage: "url(" + value.banner + ")",
                        backgroundSize: "cover",
                        backgroundPosition: "center center",
                      }}
                    ></div>
                  </div>
                </Fade>
              </div>
            </div>
          </div>
        ))}
      </section>
    </>
  );
};

export default HomeProduct;
